export default "__VITE_ASSET__BKnnM6O1__"